import React from "react";

const TooltipText = (props) => {
  const TooltipPopup = () => {
    props.parentCallback(false);
  };

  return (
    <div className="overlay">
        <div className="popup">
          <div className="popup__header">
            <h3> Flag Detail </h3>
            <span
              className="close"
              role="button"
              onClick={() => TooltipPopup(false)}
            >
              ×
            </span>
          </div>
          <div className="content flagDetail">
            <div className="popup__body">
              <h5> {props.tooltip} </h5>
            </div>
          </div>
        </div>
      </div>
  );
};

export default TooltipText;
